import messages from './Autologout.messages.js';

/**
 * US25444 enable autologout message and functionality
 */
function enableAutoLogout(alertFn, logoutFn, idleMinutes, logoutMinutes) {
    let lastAction = Date.now();
    const idleTime = idleMinutes * 60;
    const logoutTime = logoutMinutes * 60;
    setInterval(() => {
        const diff = Math.abs((Date.now() - lastAction) / 1000);
        //console.log(`idle time ${diff}, idle limit ${idleTime}`);
        if (diff > idleTime) {
            alertFn({
                title: messages.autoLogoutTitle,
                message: messages.autoLogoutBody,
                status: 'warning',
                icon: 'mi--outline',
                confirmButtonText: messages.autoLogoutContinue
            }).then((results) => {
                lastAction = Date.now();
            }, _.noop);
        }
    }, 5000);

    setInterval(() => {
        const diff = Math.abs((Date.now() - lastAction) / 1000);
        //console.log(`logout time ${diff}, logout limit ${logoutTime}`);
        if (diff > logoutTime) {
            logoutFn();
        }
    }, 5000);

    const handleClick = (event) => {
        //console.log(`handleClick`);
        lastAction = Date.now();
    };

    const handleKeyDown = (event) => {
        if (!event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
            //console.log(`handleKeyDown ${event.key}`);
            lastAction = Date.now();
        }
    };

    document.addEventListener('click', handleClick)
    document.addEventListener('keydown', handleKeyDown);
}

export default { enableAutoLogout };
